module.exports = __webpack_public_path__ + "img/login.3ff95203.png";